import { lazy } from "react";
import { serviceAccountsApi } from "@/services/accounts";
import { RouterItemType } from "@/app/index";

const LayoutPageAccount = lazy(() => import("./layout/index"));

export const PageAccountLoader = async (args: any) => {
  try {
    const { accountId } = args.params;

    if (!accountId) {
      throw new Error("ACCOUNT_ID_REQUIRED");
    }

    const account = serviceAccountsApi.fetchAccountById(accountId);

    if (!account) {
      throw new Error("ACCOUNT_NOT_FOUND");
    }

    return account;
  } catch (err) {
    console.log(err);
  }
};

export const routerPageAccount: RouterItemType = {
  path: "/accounts/:accountId",
  authorize: true,
  element: <LayoutPageAccount />,
  loader: PageAccountLoader,
};
